import React, { useState, useEffect } from "react";
import Preloader from "./../common/Preloader";

const PageWrapper = ({ fetchData, render }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPageData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetchData();
        setData(response);
      } catch (err) {
        console.error("Error fetching data:", err.message || err);
        setError(
          "Hubo un problema al cargar la información. Por favor, intenta nuevamente más tarde."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, [fetchData]);

  if (loading) {
    return <Preloader />;
  }

  if (error) {
    return (
      <div
        className="page-error" >
        <h2>¡Oops! Algo salió mal</h2>
        <p style={{ marginBottom: "20px" }}>{error}</p>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: "10px 20px",
            backgroundColor: "#0056f7",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          Reintentar
        </button>
      </div>
    );
  }

  return render(data);
};

export default PageWrapper;
